let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2hH31")).then(() => parcelRequire('iDdMo'));